/**
 * @prettier
 */
import TopBar from "./components/TopBar"
import Logo from "./components/Logo"

const TopBarPlugin = () => ({
  components: { Topbar: TopBar, Logo },
})

export default TopBarPlugin
